import React from 'react';
import PropTypes from 'prop-types';

import url from './questions/url';
import range from './questions/range';
import task from './questions/task';
import written from './questions/written';
import multiple from './questions/multiple';
import single from './questions/single';
import image from './questions/image';
import audioVideo from './questions/audio_video';
import preference from './questions/preference';
import firstClickTest from './questions/first-click-test';
import ranking from './questions/ranking';
import matrix from './questions/matrix';
import fiveSecond from './questions/five-second';

const questionTypes = {
  url,
  range,
  task,
  written,
  multiple_select: multiple,
  single_select: single,
  image_select: image,
  preference,
  audio_video: audioVideo,
  first_click_test: firstClickTest,
  ranking,
  matrix,
  five_second: fiveSecond,
};

const Question = (props) => {
  const {
    question,
    index,
    errors,
    touched,
    setFieldValue,
    isEdit,
    onChangeUrl,
    taskIndex,
    testType,
    onSetIsUploadDone,
  } = props;

  const QuestionLayout = questionTypes[question.questionType];

  return (
    <QuestionLayout
      question={question}
      index={index}
      errors={errors}
      touched={touched}
      setFieldValue={setFieldValue}
      isEdit={isEdit}
      onChangeUrl={onChangeUrl}
      taskIndex={taskIndex}
      testType={testType}
      onSetIsUploadDone={onSetIsUploadDone}
    />
  );
};

Question.propTypes = {
  isEdit: PropTypes.bool,
  question: PropTypes.shape().isRequired,
  errors: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.shape(),
  ]).isRequired,
  touched: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.shape(),
  ]).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  onChangeUrl: PropTypes.func,
  taskIndex: PropTypes.number,
  testType: PropTypes.string.isRequired,
  onSetIsUploadDone: PropTypes.func,
};

Question.defaultProps = {
  isEdit: false,
  onChangeUrl: null,
  taskIndex: null,
  onSetIsUploadDone: () => { },
};

export default Question;
